/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Reset_ButtonInputs */



/**
* | output |
* | --- |
* | "Reset" |
*
* @param {Tags_Manager_Reset_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_reset_button = /** @type {((inputs?: Tags_Manager_Reset_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Reset_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reinitialiser")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurücksetzen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reset")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перезагрузить")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reiniciar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("重置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リセット")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रीसेट करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reiniciar")
	return /** @type {LocalizedString} */ ("Reset")
});